import React, { useState } from 'react';
import { Key, FileText } from 'lucide-react';
import WebFormApiKeys from './WebFormApiKeys';
import WebFormLogs from './WebFormLogs';
import './WebFormManagement.css';

const WebFormManagement = () => {
  const [activeTab, setActiveTab] = useState('api-keys'); // 'api-keys' or 'logs'

  return (
    <div className="webform-management-container">
      <div className="webform-management-header">
        <h1>WebForm Management</h1>
        <p>Manage API keys and view submission logs</p>
      </div>

      <div className="webform-tabs">
        <button
          className={`tab-button ${activeTab === 'api-keys' ? 'active' : ''}`}
          onClick={() => setActiveTab('api-keys')}
        >
          <Key size={18} />
          <span>API Keys & Configuration</span>
        </button>
        <button
          className={`tab-button ${activeTab === 'logs' ? 'active' : ''}`}
          onClick={() => setActiveTab('logs')}
        >
          <FileText size={18} />
          <span>Submission Logs</span>
        </button>
      </div>

      <div className="webform-tab-content">
        {activeTab === 'api-keys' ? (
          <WebFormApiKeys />
        ) : (
          <WebFormLogs />
        )}
      </div>
    </div>
  );
};

export default WebFormManagement;
